
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import VerificationCom from '@/components/Header/Verification.vue'
import VeVideo from '@/components/VeVideo/index.vue'
import { vlSDKRequest , vidTypes, getParams } from '@/utils/sdk'
import iChainType from '@/components/Header/chainType.vue'
import { getLanguageDesc, getLangCode } from '@/utils/getLang'

@Component({
  components: {
    VerificationCom,
    iChainType,
    VeVideo
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private landingInfo!: any
  @Prop({ default: () => { return [] } }) private mintData!: Array<any>
  @Prop({ default: ''}) private currentLanguage!: string
  /// data
  private data: Object = {}

  private currentLang: any = ''
  private hideHeadImg: boolean = true
  private get langList(): Array<any> {
    let { language } = this.landingInfo
    return language && language.map((item: any) => {
     return {text: getLanguageDesc(item), value: getLangCode(item)} 
    }) || []
  }

  public get lpId(): any {
    let { vid, cid } = this.landingInfo
    return (cid && cid.length > 0) ? cid : vid
  }

  public get chipSimple(): any {
    let { displayType } = this.landingInfo
    console.log("displayType_", displayType)
    return displayType && displayType == 'simple'
  }
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get tags(): Array<any> {
    let {sku} = this.landingInfo

    let tagArray = sku && sku.custom && sku.custom.Productlabels && sku.custom.Productlabels.filter((item: any) =>{
      return item.label && item.label.length
    }).map((item: any) =>{
      return item.label
    }) || []

    // console.log("tagArray_",tagArray)
    return tagArray
  }
  private get skuName(): string {
    let {sku} = this.landingInfo
    return sku && sku.base && sku.base.productname
  }
  private get skuCode(): string {
    let {sku} = this.landingInfo
    return sku && sku.base && sku.base.title
  }
  private get skuDescribe(): string {
    let {sku} = this.landingInfo
    let desc = sku && sku.base && sku.base.description
    return desc && desc.replace(/\\n/g, '')
  }
  private get mainImage(): string {
    let {sku} = this.landingInfo
    return sku && sku.base && sku.base.mainimage && sku.base.mainimage.filelocation
  }
  private get buLogo(): string {
    let {buinfo} = this.landingInfo
    return buinfo && buinfo.base && buinfo.base.enlogo && buinfo.base.enlogo.filelocation || ""
  }

  private get loadingVideo(): any {
    let {activity} = this.landingInfo
    return activity && activity.custom && activity.custom.loadingvideo && activity.custom.loadingvideo.filelocation
  }

  private certDetail() {
    let { certUrl } = this.landingInfo
    if (this.$i18n.locale == 'zh-CN') {
      certUrl = certUrl + '&lang=zh'
    }
    certUrl && window.open(certUrl)
  }

  private showHeadImg() {
    this.hideHeadImg = false
  }

  private handleError() {
    this.hideHeadImg = false
  }
  private get options(): any {
    return {
          autoplay: true,
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            fullscreenToggle: false  //全屏按钮
          }
      }
  }

  /// lifecycle
  created() {
    
  }
  
  mounted() {
    // 
    this.currentLang = this.langList && this.langList[0].value
  }

  public nftDetail() {
    this.$store.state.mintData = this.mintData
    this.$router.push({name: 'NFTDetail'})
  }

  public changeLang(item: any) {
    this.$emit("changeLang", item);
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }

  @Watch('currentLanguage', {immediate: true})
  onLanguageChange(newVal: any, oldVal: any) {
    this.currentLang = newVal
  }
}
